import React, { useEffect } from 'react'
import { ModalCP } from 'submodules/nerit-framework-ui/common/components/modal/ModalCP'
import styled from 'styled-components'
import { StringUtils } from 'submodules/nerit-framework-utils/utils/StringUtils'
import { RawHtmlCP } from 'submodules/nerit-framework-ui/common/components/raw-html/RawHtmlCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { DataImportRequests } from 'submodules/nerit-aquatec-sdk/services/data-import/DataImportRequests'
import { DataImportLogResponseDTO } from 'submodules/nerit-aquatec-sdk/services/data-import/dtos/response/DataImportLogResponseDTO'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'

interface ICPProps {
    visible: boolean
    onClose: () => void
    importationLogCode?: number
}

/**
 * O log pode ser grande, por isso so eh buscado ao abrir o modal.
 */
export function ModalSamplingImportLog(props: ICPProps): JSX.Element {

    const logRequest = useRequest<DataImportLogResponseDTO>()
    useEffect(onLogRequestChange, [logRequest.isAwaiting])

    useEffect(init, [props.visible, props.importationLogCode])

    /**
     */
    function init(): void {

        if (!props.visible || !props.importationLogCode)
            return

        logRequest.runRequest(DataImportRequests.getLog(props.importationLogCode))
    }

    /**
     */
    function onLogRequestChange(): void {

        // Apenas exibe a notificacao em caso de erro. O log eh lido direto do responseData.
        RequestUtils.isValidRequestReturn(logRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE)
    }

    const log = logRequest.responseData?.log

    return (
        <ModalCP
            title={'Logs'}
            top={0}
            width={'100%'}
            visible={props.visible}
            onCancel={props.onClose}
            noFooter={true}
            loading={logRequest.isAwaiting}
        >
            <LogWrapperSCP>
                {
                    !logRequest.isAwaiting && !!log &&
                    <RawHtmlCP html={StringUtils.replaceAll(log, '\n', '<br/>')}/>
                }
            </LogWrapperSCP>
        </ModalCP>
    )
}

const LogWrapperSCP = styled.div`
    
`
